import { buildRequest, APIInterfaceWithActiveStatusI } from '.';

class OrganizationUsers implements APIInterfaceWithActiveStatusI {
  organizationName: string = '';

  constructor(organizationName: string) {
    this.organizationName = organizationName;
  }

  getAll = () => (
    buildRequest('GET', `/organizations/${this.organizationName}/users`)
  )

  getOne = (targetName: string) => (
    buildRequest('GET', `/organizations/${this.organizationName}/users/name/${targetName}`)
  )

  register = (user: any) => (
    buildRequest('POST', `/organizations/${this.organizationName}/users`, user)
  )

  update = (userId: string, user: any) => (
    buildRequest('PUT', `/organizations/${this.organizationName}/users/${userId}`, user)
  )

  setActivateStatus = (userId: string, newStatus: boolean) => (
    buildRequest('PUT', `/organizations/${this.organizationName}/users/${userId}/${newStatus ? 'activate' : 'deactivate'}`)
  )

  delete = (userId: string) => (
    buildRequest('DELETE', `/organizations/${this.organizationName}/users/${userId}`)
  )
}

export default OrganizationUsers;
